import React from "react";
import { ShoppingCart } from "lucide-react";
import { Order } from "../OrderInfo/types";

interface OrderSummaryProps {
  totalItems: number;
  totalAmount: number;
  onNotifyPatient: () => void;
  actionText?: string;
  order: Order[];
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  totalItems,
  totalAmount,
  onNotifyPatient,
  actionText = "Proceed",
  order,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 w-full max-w-md">
      {/* Top Row - Items */}
      <div className="flex items-center justify-between border-b pb-2 mb-2">
        <div className="flex items-center gap-2 text-gray-700">
          <ShoppingCart className="w-4 h-4" />
          <span className="text-sm font-medium">{totalItems} items</span>
        </div>
      </div>

      {/* Bottom Row - Total & Button */}
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs text-gray-500">Total payable</div>
          <div className="text-xl font-semibold text-gray-900">
            ₹
            {order[0]?.orderTotal != null
              ? order[0].orderTotal.toFixed(2)
              : totalAmount.toFixed(2)}
          </div>
        </div>
        <button
          onClick={onNotifyPatient}
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors text-sm"
        >
          {actionText}
        </button>
      </div>
    </div>
  );
};

export default OrderSummary;
